import { Button } from '@mui/material';
import { FullPageState } from '../../../design-system';
import {
  loginMessage,
  recoveryLoginPath,
  type LoginFailureReason,
} from '../model/login';

export function LoginPage({ reason }: { reason?: LoginFailureReason }) {
  const message = loginMessage(reason);
  return (
    <FullPageState
      title={message.title}
      description={message.description}
      action={<Button variant="contained" href={recoveryLoginPath()}>{message.actionLabel}</Button>}
    />
  );
}
